import { useState, useCallback } from 'react';
import { recibosCobroAPI, recibosCobroGrupoAPI, pagosAPI } from '../services/api';
import { movimientoTieneRecibo, movimientoTieneReciboGrupo, movimientoTienePago, esMovimientoPagoCuenta } from '../utils/impresionMovimientos';

async function cargarReciboDetalle(mov) {
  if (mov.recibo_cobro_id) {
    try {
      const res = await recibosCobroAPI.getById(mov.recibo_cobro_id);
      if (res.success && res.data) return res.data;
    } catch (_) {
      /* intentar por movimiento */
    }
  }
  try {
    const res = await recibosCobroAPI.getByMovimientoId(mov.id);
    if (res.success && res.data) return res.data;
  } catch (_) {
    /* sin recibo */
  }
  return null;
}

async function cargarPagoDetalle(mov) {
  try {
    const res = await pagosAPI.getByMovimientoId(mov.id);
    if (res.success && res.data) return { data: res.data, error: null };
  } catch (e) {
    if (mov?.numero_pago || mov?.numero_pago_cuenta) {
      const etiqueta = esMovimientoPagoCuenta(mov) ? 'pago a cuenta' : 'orden';
      return { data: null, error: e.message || `No se pudieron cargar las formas de pago de la ${etiqueta}` };
    }
  }
  return { data: null, error: null };
}

export function useMovimientoDetalle() {
  const [detalleMovimiento, setDetalleMovimiento] = useState(null);
  const [detalleRecibo, setDetalleRecibo] = useState(null);
  const [detalleReciboGrupo, setDetalleReciboGrupo] = useState(null);
  const [detallePago, setDetallePago] = useState(null);
  const [detallePagoError, setDetallePagoError] = useState(null);
  const [detalleLoading, setDetalleLoading] = useState(false);

  const cerrarDetalle = useCallback(() => {
    setDetalleMovimiento(null);
    setDetalleRecibo(null);
    setDetalleReciboGrupo(null);
    setDetallePago(null);
    setDetallePagoError(null);
  }, []);

  const abrirDetalle = useCallback(async (mov) => {
    setDetalleMovimiento(mov);
    setDetalleRecibo(null);
    setDetalleReciboGrupo(null);
    setDetallePago(null);
    setDetallePagoError(null);
    if (mov?.recibo_cobro_grupo_id || movimientoTieneReciboGrupo(mov)) {
      setDetalleLoading(true);
      try {
        const res = await recibosCobroGrupoAPI.getById(mov.recibo_cobro_grupo_id);
        if (res.success && res.data) setDetalleReciboGrupo(res.data);
      } catch (e) {
        console.error('Error al cargar detalle del recibo de grupo', e);
      } finally {
        setDetalleLoading(false);
      }
    } else if (movimientoTieneRecibo(mov)) {
      setDetalleLoading(true);
      try {
        const data = await cargarReciboDetalle(mov);
        if (data) setDetalleRecibo(data);
      } catch (e) {
        console.error('Error al cargar detalle del recibo', e);
      } finally {
        setDetalleLoading(false);
      }
    } else if (movimientoTienePago(mov)) {
      setDetalleLoading(true);
      try {
        const { data, error } = await cargarPagoDetalle(mov);
        if (data) setDetallePago(data);
        if (error) setDetallePagoError(error);
      } catch (e) {
        console.error('Error al cargar detalle del pago', e);
        if (mov?.numero_pago || mov?.numero_pago_cuenta) {
          const etiqueta = esMovimientoPagoCuenta(mov) ? 'pago a cuenta' : 'orden';
          setDetallePagoError(`No se pudieron cargar las formas de pago de la ${etiqueta}`);
        }
      } finally {
        setDetalleLoading(false);
      }
    }
  }, []);

  return {
    detalleMovimiento,
    detalleRecibo,
    detalleReciboGrupo,
    detallePago,
    detallePagoError,
    detalleLoading,
    abrirDetalle,
    cerrarDetalle,
  };
}
